/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PraticaEsercenteDetailDTO } from './pratica-esercente-detail-dto';
import { PageMetadata } from './page-metadata';


export interface PagedModelPraticaEsercenteDetailDTO { 
    content?: Array<PraticaEsercenteDetailDTO>;
    page?: PageMetadata;
}

